import ENDPOINT from "@/api/endpoints";
import {
  callApiCapNhatNguoiDungTrongVaiTro,
  callApiCapNhatQuyenTrongVaiTro,
  callApiCapNhatThongTinVaiTro,
  callApiLayChiTietVaiTro,
  callApiLayDanhSachNguoiDung,
  callApiLayDanhSachNguoiDungKhongThuocVaiTro,
  callApiLayDanhSachQuyenKhongThuocVaiTro,
  callApiLayDanhSachVaiTro,
  callApiTaoVaiTro,
  callApiXoaVaiTro,
  callApiLayDanhSachVaiTroTheoApp,
  callApiLayDanhSachVaiTroKhongThuocGroup
} from "@/api/role";
import { showMsgError, showMsgOk } from "@/utils/commonUtils";
import { XOA_VAI_TRO_THANH_CONG } from "@/constants/message";

const layDanhSachVaiTro = (context, payload) => {
  callApiLayDanhSachVaiTro(payload, ENDPOINT.ROLE.DANH_SACH_VAI_TRO)
    .then(response => {
      if (response) {
        context.commit("SET_DANH_SACH_VAI_TRO", response.data.data);
      }
    })
    .catch(error => {
      showMsgError(error.response.data.message);
    });
};

const layChiTietVaiTro = (context, payload) => {
  callApiLayChiTietVaiTro(payload, ENDPOINT.ROLE.CHI_TIET_VAI_TRO)
    .then(response => {
      if (response) {
        context.commit("SET_CHI_TIET_VAI_TRO", response.data.data);
      }
    })
    .catch(error => {
      showMsgError(error.response.data.message);
    });
};

const xoaVaiTro = async (context, payload) => {
  try {
    const response = await callApiXoaVaiTro(payload);
    if (response && response.data.succeeded) {
      showMsgOk(XOA_VAI_TRO_THANH_CONG);
    }
  } catch (error) {
    showMsgError(error.response.data.message);
  }
};

const taoVaiTro = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoVaiTro(payload, ENDPOINT.ROLE.TAO_VAI_TRO)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
};

const capNhatThongTinVaiTro = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatThongTinVaiTro(
      payload,
      ENDPOINT.ROLE.CAP_NHAT_THONG_TIN_VAI_TRO
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
};


const layDanhSachQuyenKhongThuocVaiTro = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachQuyenKhongThuocVaiTro(
      payload,
      ENDPOINT.ROLE.DANH_SACH_QUYEN_KHONG_THUOC_VAI_TRO
    )
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_QUYEN_KHONG_THUOC_VAI_TRO",
            response.data.data
          );
        }
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
};

const capNhatQuyenTrongVaiTro = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatQuyenTrongVaiTro(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
};

const layDanhSachNguoiDungTheoVaiTro = (context, payload) => {
  callApiLayDanhSachNguoiDung(payload, ENDPOINT.ROLE.NGUOI_DUNG_THEO_VAI_TRO)
    .then(response => {
      if (response) {
        context.commit(
          "SET_DANH_SACH_NGUOI_DUNG_THEO_VAI_TRO",
          response.data.data
        );
      }
    })
    .catch(error => {
      showMsgError(error.response.data.message);
    });
};

const layDanhSachNguoiDungKhongThuocVaiTro = (context, payload) => {
  callApiLayDanhSachNguoiDungKhongThuocVaiTro(
    payload,
    ENDPOINT.ROLE.NGUOI_DUNG_KHONG_THUOC_VAI_TRO
  )
    .then(response => {
      if (response) {
        context.commit(
          "SET_DANH_SACH_NGUOI_DUNG_KHONG_THUOC_VAI_TRO",
          response.data.data
        );
      }
    })
    .catch(error => {
      showMsgError(error.response.data.message);
    });
};

const capNhatNguoiDungTrongVaiTro = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatNguoiDungTrongVaiTro(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      });
  });
};

const layDanhSachVaiTroTheoApp = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachVaiTroTheoApp(payload).then((response) => {
      if (response) {
        context.commit("SET_DANH_SACH_VAI_TRO_THEO_APP", response.data.data)
      }
      resolve(response);
    }).catch((error) => {
      reject(error)
    });
  })
}

const layDanhSachVaiTroKhongThuocGroup = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachVaiTroKhongThuocGroup(payload).then((response) => {
      if (response) {
        context.commit("SET_DANH_SACH_VAI_TRO_KHONG_THUOC_GROUP", response.data.data)
      }
      resolve(response);
    }).catch((error) => {
      reject(error)
    });
  })
}

// const layDanhSachNguoiDungTheoGroup = (context, payload) => {
//   callApiLayDanhSachNguoiDungTheoGroup(payload, ENDPOINT.ROLE.NGUOI_DUNG_THEO_GROUP)
//     .then(response => {
//       if (response) {
//         context.commit(
//           "SET_DANH_SACH_NGUOI_DUNG_THEO_GROUP",
//           response.data.data
//         );
//       }
//     })
//     .catch(error => {
//       console.error(error);
//     });
// };

export default {
  layDanhSachVaiTro,
  layChiTietVaiTro,
  taoVaiTro,
  capNhatThongTinVaiTro,
  layDanhSachNguoiDungTheoVaiTro,
  capNhatNguoiDungTrongVaiTro,
  xoaVaiTro,
  capNhatQuyenTrongVaiTro,
  layDanhSachQuyenKhongThuocVaiTro,
  layDanhSachNguoiDungKhongThuocVaiTro,
  // layDanhSachNguoiDungTheoGroup
  layDanhSachVaiTroTheoApp,
  layDanhSachVaiTroKhongThuocGroup
};
